import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

import './config/reset.css';
import './config/default.css';
import './config/mixins.css';
import './config/typography.css';
import './config/layout.css';

import ConnectedRoutes from './routes/components/ConnectedRoutes';

const ignoreMessages = [
  'Blocked a frame with origin "https://www.casapilot.com" ' +
    'from accessing a cross-origin frame. Protocols, domains, and ports must match.',
  "Object doesn't support property or method 'assign'",
  "Object doesn't support property or method 'includes'",
  'Object.values is not a function',
];

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://33d0bd5365094afe8b8eee7d2f415077@o1133369.ingest.sentry.io/6183883',
    allowUrls: [/https:\/\/www.casapilot.com/],
    ignoreErrors: ['top.GLOBALS'],
    beforeSend(event, hint) {
      try {
        const error = hint?.originalException;
        if (!error || typeof error === 'string' || !error.message) {
          return event;
        }
        if (ignoreMessages.includes(error.message)) {
          return null;
        }
        return event;
      } catch (e) {
        return event;
      }
    },
  });
}

ReactDOM.render(<ConnectedRoutes />, document.getElementById('root'));
